module.exports = __webpack_public_path__ + "static/media/logo1.1f5387d8.png";